import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import {
  BreadcrumbModule,
  DropdownModule,
  EmptyStateModule,
  LogoModule,
  NavbarModule,
  SidebarModule,
  LoaderModule,
  IconModule,
  TableModule,
  ModalModule
} from '@michelin/theme';
import { SpecDropdownComponent } from './components/spec-dropdown/spec-dropdown.component';
import { DropdownMultipleSearchComponent } from './components/dropdown-multiple-search/dropdown-multiple-search.component';
import { SharedDialogComponent } from './components/shared-dialog/shared-dialog.component';
import { CustomModalPopupComponent } from './components/custom-modal-popup/custom-modal-popup.component';
import { DropdownSearchSingleSelectComponent } from './components/dropdown-search-single-select/dropdown-search-single-select.component';
import { CustomerAssignComponent } from './components/customer-assign/customer-assign.component';
import { CustomerAssignWrapperComponent } from './components/customer-assign/customer-assign-wrapper.component';
import { ExportToExcelComponent } from './components/export-to-excel/export-to-excel.component';
import { DescPropertyPipe } from './utility/desc-property.pipe';
import { AlphanumericOnlyDirective } from './directives/alphanumeric-only.directive';
import { CopyOnSelectDirective } from './directives/copy-on-select.directive';
import { CopySelectionPopupComponent } from './components/copy-selection-popup/copy-selection-popup.component';
import { SharedDeleteModalComponent } from './components/shared-delete-modal/shared-dialog.component';
import { SharedWarningModalComponent } from './components/shared-warning-modal/shared-warning-modal.component';
import { AccessDeniedComponent } from './components/access-denied/access-denied.component';
import { ExportModalComponent } from './components/export-modal/export-modal.component';
import { NotificationBannerCardComponent } from './components/notification-banner-card/notification-banner-card.component';
import { MichelinDropdownAccessibilityDirective } from './directives/michelin-dropdown-accessibility.directive';

const modules = [
  CommonModule,
  ReactiveFormsModule,
  FormsModule,
  BreadcrumbModule,
  DropdownModule,
  SidebarModule,
  NavbarModule,
  LogoModule,
  LoaderModule,
  IconModule,
  EmptyStateModule,
  MatButtonModule,
  MatCheckboxModule,
  MatDialogModule,
  MatDividerModule,
  MatIconModule
];

@NgModule({
  imports: [
    ...modules,
    MatCardModule,
    CustomModalPopupComponent,
    TableModule,
    ModalModule,
    DescPropertyPipe,
    AlphanumericOnlyDirective,
    CopyOnSelectDirective,
    MichelinDropdownAccessibilityDirective,
    CopySelectionPopupComponent
  ],
  declarations: [
    SpecDropdownComponent,
    DropdownMultipleSearchComponent,
    SharedDialogComponent,
    SharedDeleteModalComponent,
    SharedWarningModalComponent,
    DropdownSearchSingleSelectComponent,
    CustomerAssignComponent,
    CustomerAssignWrapperComponent,
    ExportToExcelComponent,
    AccessDeniedComponent,
    ExportModalComponent,
    NotificationBannerCardComponent
  ],
  exports: [
    ...modules,
    SpecDropdownComponent,
    DropdownMultipleSearchComponent,
    DropdownSearchSingleSelectComponent,
    CustomerAssignComponent,
    CustomerAssignWrapperComponent,
    ExportToExcelComponent,
    DescPropertyPipe,
    AlphanumericOnlyDirective,
    CopyOnSelectDirective,
    MichelinDropdownAccessibilityDirective,
    CopySelectionPopupComponent,
    AccessDeniedComponent,
    ExportModalComponent,
    NotificationBannerCardComponent
  ],
  providers: []
})
export class SharedModule {}
